import img1 from "../../assets/Images/Banquet Setup/Banquet Setup Service cards.png"
import img2 from "../../assets/Images/Banquet Setup/add service item popup.png"
import img3 from "../../assets/Images/Banquet Setup/edit service popup.png"

export default function ServiceCards() {
    return (
        <section id="service-cards" className="space-y-16">

            {/* SECTION TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    2. Service Cards
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    Service Cards define all additional services offered with an event,
                    such as seating, refreshments, décor, sound-related items, and other
                    billable add-ons.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        The Service Cards module acts as a master catalog of services that can
                        be attached to event estimates and bookings. Each service defines how
                        it is priced, displayed, and calculated in financial totals.
                    </p>
                </section>
            </section>

            {/* SERVICE LIST */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Service Items List
                    </h3>

                    <p className="text-slate-600 mb-4">
                        When the Service Cards module is opened, all configured service items
                        are displayed in a searchable table.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Service Title (e.g. Extra Seating, Welcome Drinks)</li>
                        <li>Pricing Type (Flat / Per Head)</li>
                        <li>Service Price</li>
                        <li>Active status</li>
                        <li>Edit and Delete actions</li>
                    </ul>
                </div>

                <div className="rounded-lg p-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ADD SERVICE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Adding a New Service Item
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Add Service Item</strong> button opens a popup
                    form where new services can be created.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Title:</strong> Name of the service (e.g. DJ, Extra Seating)
                    </li>
                    <li>
                        <strong>Pricing Type:</strong> Flat or Per Head
                    </li>
                    <li>
                        <strong>Show By:</strong> Service category for grouping and display
                    </li>
                    <li>
                        <strong>Description:</strong> Optional details about the service
                    </li>
                    <li>
                        <strong>Price:</strong> Base amount for calculation
                    </li>
                    <li>
                        <strong>Unit Label:</strong> Optional label such as per head, per hour, or each
                    </li>
                    <li>
                        <strong>Active:</strong> Toggle to enable or disable service usage
                    </li>
                </ul>

                <p className="text-slate-600 mt-4">
                    A live price preview is shown at the bottom of the form, helping staff
                    verify the pricing before saving.
                </p>

                <div className="rounded-lg p-4 mt-4 flex justify-center items-center">
                   <img src={img2} alt="" className="w-[500px] h-auto" />
                </div>
            </section>

            {/* PRICING TYPES */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Pricing Types Explained
                </h3>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Flat:</strong> Fixed amount regardless of guest count
                    </li>
                    <li>
                        <strong>Per Head:</strong> Price multiplied by number of guests
                    </li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Pricing type directly affects how totals are calculated in estimates,
                    bookings, invoices, and reports.
                </p>
            </section>

            {/* EDIT SERVICE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Editing a Service Item
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Edit</strong> action opens the same service form
                    with existing values auto-filled.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Update service name or pricing</li>
                    <li>Change pricing type or unit label</li>
                    <li>Enable or disable the service</li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Changes take effect immediately and reflect across all future
                    estimates and bookings.
                </p>

                <div className=" rounded-lg p-4 mt-4 flex items-center justify-center">
                    <img src={img3} className="w-[500px] h-auto" />
                </div>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Service Cards Matter
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Centralized service management ensures consistent pricing, eliminates
                    manual calculations, and provides accurate financial reporting across
                    the entire banquet operation.
                </p>
            </section>

        </section>
    );
}
